import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../service/customer.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {

  resultTable: any[] = null;
  cols: any[];
  msgs: any[] = [];
  showButtonsColumn: any = true;
  viewTypeOptions: any[];
  selectedViewType: any;

  showAccountManagerEdit: boolean = false;
  accountManagerName: any;
  accountManagerEMail: any;
  accountManagerCustomerNumber: any;
  accountManagerCustomerName: any;
  accountManagerRowData: any;

  constructor(private dataService: CustomerService, private router: Router) { }

  ngOnInit() {
    this.viewTypeOptions = [
      {label:'תצוגת פרטי מעסיקים', value: 1},
      {label:'תצוגת פרטי קשר', value: 2}
    ];
    this.selectedViewType = this.viewTypeOptions[0].value;
    this.fillCustomers();
  }

  fillCustomers() {
    this.cols = [
      { field: 'Active', header: 'פעיל', viewType: 0 },
      { field: 'IdentityNumber', header: 'זיהוי מעסיק', viewType: 0  },
      { field: 'SerialNumber', header: 'מספר סידורי', viewType: 0  },
      { field: 'KodSugMaasik', header: 'סוג מעסיק', viewType: 0  },
      { field: 'CustomerName', header: 'שם מעסיק', viewType: 0  },
      // { field: 'KodSugMaasikId', header: 'קוד סוג מעסיק', viewType: 1  },
      { field: 'ContactName', header: 'שם איש קשר', viewType: 2  },
      { field: 'ContactEmail', header: 'מייל איש קשר', viewType: 2  },
      { field: 'ContactPhone', header: 'טלפון איש קשר', viewType: 2  },
      { field: 'AccountManagerName', header: 'שם מנהל תיק', viewType: 2, showAccountManagerDialog: true  },
      { field: 'AccountManagerEmail', header: 'מייל מנהל תיק', viewType: 2  },
      { field: 'InsuranceAgentName', header: 'שם סוכן ביטוח', viewType: 2  },
      { field: 'InsuranceAgentEmail', header: 'מייל סוכן ביטוח', viewType: 2  },
      { field: 'AccountantName', header: 'שם איש כספים', viewType: 2  },
      { field: 'AccountantEmail', header: 'מייל איש כספים', viewType: 2  },
      { field: 'InvoiceMail', header: 'מייל חשבונית', viewType: 2  },
      { field: 'InvoiceMail2', header: 'מייל חשבונית 2', viewType: 2  },
      { field: 'BankNumber', header: 'מספר בנק', viewType: 1  },
      { field: 'BankName', header: 'שם בנק', viewType: 1  },
      { field: 'BankBranchName', header: 'סניף', viewType: 1  },
      { field: 'AccountNameBank', header: 'חשבון', viewType: 1  },
      { field: 'CostSingle', header: 'מחיר אחיד לתז', viewType: 1  },
      { field: 'CostForX', header: 'מחיר כולל ל-X', viewType: 1  },
      { field: 'X', header: 'X', viewType: 1  },
      // { field: 'Cost10', header: 'עלות 10', viewType: 1  },
      { field: 'Cost30', header: 'מחיר מעל X', viewType: 1  },
      { field: 'Cost30More', header: 'עלות מעל 30', viewType: 1  },
      { field: 'MaximumEmployees', header: 'מספר עובדים מקסימלי', viewType: 1  },
      { field: 'isTaxFree', header: 'פטור ממע"מ', viewType: 1  },
      { field: 'XmlMachineType', header: 'תשלום לקופות', viewType: 1  },
      // { field: 'Phone', header: 'טלפון', viewType: 1  },
      // { field: 'ContactFirstName', header: 'שם פרטי', viewType: 1  },
      // { field: 'ContactLastName', header: 'שם משפחה', viewType: 1  },
      // { field: 'InstitutionCode', header: 'קוד מוסד', viewType: 1  },
      // { field: 'AgenEmail', header: 'מייל סוכן', viewType: 1  },
      // { field: 'CustomerMosadCode', header: 'מזהה במוסד', viewType: 1  },
      // { field: 'Contact2Name', header: 'שם איש קשר משני', viewType: 1  },
      // { field: 'Contact2Phone', header: 'טלפון איש קשר משני', viewType: 1  },
      // { field: 'Contact2Email', header: 'מייל איש קשר משני', viewType: 1  },
      

    ];

    this.dataService.getCustomers().subscribe((result: any) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
      });

  }

  deactivate(identityNumber: any): void {
    if (confirm('האם ברצונך לקבוע את המעסיק כלא פעיל? '))
    {
      this.dataService.deactivate(identityNumber).subscribe((result: any) => {
        this.fillCustomers();
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בעדכון מעסיק כלא פעיל ');
      });
    }
  }

  setAllowSecondReminder(identityNumber: any, allow: any): void {
   
    this.dataService.SetAllowSecondReminder(identityNumber, allow).subscribe((result: any) => {
      this.fillCustomers();
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בעדכון אפשרות להפצת תזכורת שניה למעסיק ');
    });
  }

  setAllowFirstReminder(identityNumber: any, allow: any): void {
   
    this.dataService.SetAllowFirstReminder(identityNumber, allow).subscribe((result: any) => {
      this.fillCustomers();
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בעדכון אפשרות להפצת תזכורת שניה למעסיק ');
    });
  }

  setAllowLossWorkCapacityReminder(identityNumber: any, allow: any): void {
   
    this.dataService.setAllowLossWorkCapacityReminder(identityNumber, allow).subscribe((result: any) => {
      this.fillCustomers();
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בעדכון אפשרות תזכורת א.כ.ע למעסיק ');
    });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showAccountManager(rowData) {
    this.showAccountManagerEdit = true;
    this.accountManagerRowData = rowData;
    this.accountManagerName = rowData['AccountManagerName'];
    this.accountManagerEMail = rowData['AccountManagerEmail'];
    this.accountManagerCustomerNumber = rowData['IdentityNumber'];
    this.accountManagerCustomerName = rowData['CustomerName'];
  }

  closeAccountManager() {
    this.showAccountManagerEdit = false;
    this.accountManagerRowData = null;
  }

  saveAccountManager() {
    this.dataService.saveCustomerAccountManager(this.accountManagerCustomerNumber, this.accountManagerName, this.accountManagerEMail).subscribe((result: any) => {
      this.accountManagerRowData['AccountManagerName'] = this.accountManagerName;
      this.accountManagerRowData['AccountManagerEmail'] = this.accountManagerEMail;
      this.showAccountManagerEdit = false;
      this.accountManagerRowData = null;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בעדכון פרטי מנהל תיק ');
    });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customer-list/customer-list.component.ts